import Preview3D from "../components/Preview3D";

const Preview = () => {
  return (
    <main className="bg-surface min-h-screen flex items-center justify-center p-4">
      <div className="w-full h-[400px] max-w-md">
        <Preview3D image="/examples/template1/temp1_examp1.png" logo="/logo.png" />
      </div>
    </main>
  );
};

export default Preview;